import { FormControl } from 'react-bootstrap'

// just a shim since we cant import FormControl.Feedback directly in FormGroup.es

export default FormControl.Feedback
